import React from "react";
import { Routes, BrowserRouter as Router, Route } from "react-router-dom";
import Home from './pages/Home';
import ThankYou from './pages/thankyou';
import Header from './components/Header';

function App() {
  return (
    <>
   {/* UAT : '/v2/46725/lp/services/seniorCitizen/wb', package.json :'/v2/46725/lp/services/seniorCitizen/wb' */}
           {/* LIVE - {window.location.pathname} - package.json -> homepage =/services/seniorCitizen/wb */}
        <Router basename={window.location.pathname}> 
      {/* <Router basename={'demo/senior-citizen'}> */} 
    
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route path="/thankyou" element={<ThankYou />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;